'use strict';

angular.module('app.mentions', [])
    .controller('mentionsCtrl', ['$scope', '$rootScope', '$modal', '$http', 'mentionsService', 'adminService', 'mentionManagementService',
        function ($scope, $rootScope, $modal, $http, mentionsService, adminService, mentionManagementService) {

            mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function(response) {
                    $scope.languages = response.data;
                }, function(errResponse) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = errResponse.message;
                })

            $scope.topics = [];
            var topicObject = {
                id: 1,
                name: "No Topic"
            }

            $scope.topics.push(topicObject);
            var url_getAllMentionTopic = $rootScope.apiUrl + 'mention/getAllTopic';
            $http.get(url_getAllMentionTopic, {loader: false})
                .success(function(responseGetMentionTopic){
                    angular.forEach(responseGetMentionTopic.data, function(item) {
                        $scope.topics.push(item);
                    })
                }) 

            $scope.verticals = [];
            var verticalObject = {
                id: 1,
                name: "No Industry"
            }

            $scope.verticals.push(verticalObject);
            var url_getAllMentionVertical = $rootScope.apiUrl + 'mention/getAllVertical';
            $http.get(url_getAllMentionVertical, {loader: false})
                .success(function(responseGetMentionVertical){
                    angular.forEach(responseGetMentionVertical.data, function(item) {
                        $scope.verticals.push(item);
                    })
                }) 

            var url_getKeywordApproval = $rootScope.apiUrl + 'mention/getKeywordApproval';
            $http.get(url_getKeywordApproval, {loader: false})
                .success(function(responseGetKeywordApproval){
                    $scope.approval = responseGetKeywordApproval.data;
                }) 

            var url_getMentionKeywordType = $rootScope.apiUrl + 'mention/getKeywordType';
            $http.get(url_getMentionKeywordType, {loader: false})
                .success(function(responseGetKeywordType){
                    $scope.types = responseGetKeywordType.data;
                }) 

            $scope.preLoaded = false;
            $scope.mentions = [];
            $scope.currentPage = 1;
            $scope.pageSize = 25;
            $scope.currentUrl = $rootScope.apiUrl + 'mention/searchMention';
            $scope.currentData = null;
            $scope.searchString = null;
            $scope.selectedTopicId = [];
            $scope.selectedVerticalId = [];  
            $scope.selectedLanguageId = [];  
            $scope.selectedType = null;  
            $scope.selectedApproval = null;
            
            $scope.loadData = function(){
               var data = {
                    searchString: $scope.searchString,
                    selectedTopicId: $scope.selectedTopicId,
                    selectedVerticalId: $scope.selectedVerticalId,
                    selectedLanguageId: $scope.selectedLanguageId,
                    selectedType: $scope.selectedType,
                    selectedApproval: $scope.selectedApproval,        
                    pageNo: $scope.currentPage
               } 

               var url_searchMention = $scope.currentUrl;
               $scope.preLoaded = true;

               $scope.sendHttpPOST(data, url_searchMention);
            }

            $scope.sendHttpPOST = function(data, url){
                var req = {
                    url: url,
                    method: 'POST',
                    data: JSON.stringify(data)
                } 
                
                $scope.mentions = [];
                $http(req).success(function (responseSearchMention) {
                    var url_getAllMentionLanguage = $rootScope.apiUrl + 'mention/getAllLanguage';
                        $http.get(url_getAllMentionLanguage, {loader: false})
                            .success(function(response2){
                                $scope.globalLanguage = response2.data.length;
                                angular.forEach(responseSearchMention.data, function(item) {
                                    $scope.mentions.push(item);
                                    if($scope.globalLanguage == item.languages.length){
                                        var language = {
                                            id: null,
                                            name: 'Global'
                                        }
                                        item.languages = [];
                                        item.languages.push(language);
                                    }
                                })
                            })   

                    $scope.number = responseSearchMention.totalRow;
                    $scope.pagination();
                }) .error(function (data) {
                    });       
            }

            if(!$scope.preLoaded){
                $scope.loadData();
            }

            $scope.pagination = function(){
                $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
            };

            $scope.updatePage = function(val){
                $scope.currentPage = val;
                var data = {
                    searchString: $scope.searchString,
                    selectedTopicId: $scope.selectedTopicId,
                    selectedVerticalId: $scope.selectedVerticalId,
                    selectedLanguageId: $scope.selectedLanguageId,
                    selectedType: $scope.selectedType,
                    selectedApproval: $scope.selectedApproval,        
                    pageNo: $scope.currentPage
               } 

               var url_searchMention = $scope.currentUrl;

               $scope.sendHttpPOST(data, url_searchMention);
            }

            $scope.resetFilter = function() {
                $scope.languages.forEach(function (val) {
                    val.ticked = false;
                })

                $scope.topics.forEach(function (val) {
                    val.ticked = false;
                })

                $scope.verticals.forEach(function (val) {
                    val.ticked = false;
                })

                $scope.types.forEach(function (val) {
                    val.ticked = false;
                    $scope.selectedType = null;
                })

                $scope.approval.forEach(function (val) {
                    val.ticked = false;
                    $scope.selectedApproval = null;
                })

                $scope.searchString = "";
            }

            $scope.searchMention = function(){

                $scope.selectedTopicId = [];
                $scope.topics.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedTopicId.push(val.id);
                });

                $scope.selectedVerticalId = [];
                $scope.verticals.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedVerticalId.push(val.id);
                });

                $scope.types.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedType = val.id;
                });

                $scope.selectedLanguageId = [];
                $scope.languages.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedLanguageId.push(val.id)
                });

                $scope.approval.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedApproval = val.id;
                }); 

                var data = {
                    searchString: $scope.searchString,
                    selectedTopicId: $scope.selectedTopicId,
                    selectedVerticalId: $scope.selectedVerticalId,
                    selectedLanguageId: $scope.selectedLanguageId,
                    selectedType: $scope.selectedType,
                    selectedApproval: $scope.selectedApproval,        
                    pageNo: 1 
                }

                $scope.currentPage = 1;

                var url_searchMention = $scope.currentUrl;

                $scope.sendHttpPOST(data, url_searchMention);        
            }

            $scope.mentionDetails = function (id) {
                var mentionDetailsModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/mention/mentions/mentionDetail/mentionDetail.html?app_v=deployDate',
                    controller: 'mentionDetailCtrl',
                });
                $scope.id = id;
                $scope.mentionDetailsModalInstance = mentionDetailsModalInstance;

            } 

            $scope.$watch('selectedLanguage', function(newValue, oldValue){
                $scope.detail_language_old = [];
                $scope.detail_language_new = [];

                if(newValue !== oldValue && newValue !== undefined){
                    
                    angular.forEach(oldValue, function(val){
                        $scope.detail_language_old.push(val.name);
                    })
                    
                    angular.forEach(newValue, function(val){
                        $scope.detail_language_new.push(val.name);
                    })
                    angular.forEach($scope.detail_language_old,function(lang){
                        $scope.detail_language_new.splice($scope.detail_language_new.indexOf(lang),1);
                    })
                    angular.forEach($scope.detail_language_new, function(newLanguage){
                        if(newLanguage == "Global" && $scope.detail_language_old.indexOf("Global") < 0){
                            angular.forEach($scope.languages,function(lang){
                                lang.ticked = false;
                            })
                            $scope.languages[0].ticked = true;

                        } else{
                            $scope.languages[0].ticked = false;;
                        }
                    })
                    
                }
            }); 
        }  
])